import { useEffect, useState } from 'react'
import api, { INeighborhoodImportFailed } from '@api'
import { IGridTableCell, GridTableStatusEnum } from '@ui'

export interface INeighborhoodImportFailedWithId extends INeighborhoodImportFailed {
  id: string
  employee_neighborhood?: null
}

export default function useImportFailed(id: string): {
  failedImportNeighborhoods: IGridTableCell<INeighborhoodImportFailedWithId>[]
  status: GridTableStatusEnum
} {
  const [failedImportNeighborhoods, setImportFailed] = useState<
    IGridTableCell<INeighborhoodImportFailedWithId>[]
  >([])
  const [status, setStatus] = useState<GridTableStatusEnum>(GridTableStatusEnum.LOADING)

  useEffect(() => {
    api.neighborhood.import.failed(id).then(({ failed }) => {
      if (failed) {
        const newFailed = failed.map((f) => ({ data: { ...f, id: '' } }))
        setImportFailed(newFailed)
      }
      setStatus(GridTableStatusEnum.IDLE)
    })
  }, [id])

  return {
    failedImportNeighborhoods,
    status,
  }
}
